import {store as AppStore} from '../../store/store';
import {sendProfileData} from '../../store/slices/me_slice.ts';
import {LeadTypes} from '../../enums/leads/lead_types.ts';
import {isRejected} from '@reduxjs/toolkit';
import {getLeadProvider} from '../partials/get_lead_provider.ts';
import {createLead} from '../../store/slices/leads_slice.ts';
import {redirect} from 'react-router-dom';

export async function postOfferForm(store: typeof AppStore, request: Request) {
    const formData = await request.formData();
    formData.delete('tradein');
    const profileEntries = Array.from(formData.entries()).filter(
        ([key]) =>
            !key.includes('license_plate') &&
            !key.includes('mileage') &&
            !key.includes('remarks') &&
            !key.includes('occasion') &&
            !key.includes('url'),
    );
    const data = profileEntries.map(([key, value]) => {
        return {
            key,
            value: value.toString(),
        };
    });
    const token = store.getState().exchangeToken.token;
    let customerId = null;
    if (token) {
        const profileResult = await store.dispatch(sendProfileData({token, data}));
        if (isRejected(profileResult)) {
            throw profileResult.error;
        }
        customerId = store.getState().customerInfo?.me?.id ?? null;
    }

    const leadData = [
        {
            key: 'extra',
            value: JSON.stringify({
                occasion_name: formData.get('occasion_name')?.toString() ?? '',
                occasion_identifier: formData.get('occasion_identifier')?.toString() ?? '',
                trade_identifier: formData.get('license_plate')?.toString() ?? '',
                trade_mileage: formData.get('mileage')?.toString() ?? '',
                url: formData.get('url')?.toString() ?? '',
            }),
        },
        {
            key: 'occasion_id',
            value: formData.get('occasion_id')?.toString() ?? '',
        },
        {
            key: 'remarks',
            value: formData.get('remarks')?.toString() ?? '',
        },
        {
            key: 'type',
            value: LeadTypes.OccasionOffer,
        },
    ];

    const leadProviderId = await getLeadProvider(store);

    if (!leadProviderId) {
        throw new Error('No lead provider found');
    }

    const createLeadResult = await store.dispatch(
        createLead({
            customerData: data,
            leadData: leadData,
            leadProviderId: leadProviderId,
            leadType: LeadTypes.OccasionOffer,
            customerId: customerId,
        }),
    );

    if (isRejected(createLeadResult)) {
        throw createLeadResult.error;
    }

    return redirect(`/occasion/${formData.get('occasion_id')}/bedankt/offer`);
}
